import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";

const db = getFirestore();

if (process.env.VUE_APP_FIREBASE_EMULATORS === "TRUE") {
  connectFirestoreEmulator(
    db,
    process.env.VUE_APP_FIREBASE_EMULATORS_FIRESTORE_HOST,
    process.env.VUE_APP_FIREBASE_EMULATORS_FIRESTORE_PORT
  );
}

export default db;
